import { logout } from '@/redux/auth/routines';

const rootReducer = (appReducers) => (state, action) => {
  const appResetConditions = [logout.SUCCESS];
  const { type } = action;
  if (appResetConditions.includes(type)) {
    console.log('Resetting state');
    return appReducers(undefined, action);
  }
  return appReducers(state, action);
};

export default rootReducer;
